var React = require('react');

function MobileExtension (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 6h18a2 2 0 0 1 2 2v.5h-4.843a4.5 4.5 0 0 0-3.182 1.318l-1.157 1.157A3.5 3.5 0 0 1 23.343 12H13V8a2 2 0 0 1 2-2zm15.157 3.5H35V40a2 2 0 0 1-2 2H15a2 2 0 0 1-2-2V13h10.343a4.5 4.5 0 0 0 3.182-1.318l1.157-1.157A3.5 3.5 0 0 1 30.157 9.5zM11 8a4 4 0 0 1 4-4h18a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H15a4 4 0 0 1-4-4V8zm19.5 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm-15 5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7zm-.5 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm1 4.5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V25a1 1 0 0 0-1-1H16z","fill":"#fff"}));
}

MobileExtension.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = MobileExtension;

MobileExtension.default = MobileExtension;
